import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking-pr',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f-pr', 'age-tai-chi-walking-f-pr'],
		route: {
			path: '/tai-chi-walking-f-pr',
			name: 'tai-chi-walking-f-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi-walking-pr',
		route: {
			path: '/tai-chi-walking-f-pr/ob/:page(.*)?',
			name: 'activity-female-tai-chi-walking-pr',
		},
		slug: 'activity-female-tai-chi-walking-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-walking-f-pr',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
}

export default appAreaConfig
